import { render, staticRenderFns } from "./Voting.vue?vue&type=template&id=20598cd0&scoped=true"
import script from "./Voting.vue?vue&type=script&lang=js"
export * from "./Voting.vue?vue&type=script&lang=js"
import style0 from "./Voting.vue?vue&type=style&index=0&id=20598cd0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20598cd0",
  null
  
)

export default component.exports